import { useEffect } from "react";
import GLightbox from "glightbox";

export const useLightbox = (selector = ".portfolio-lightbox", options = {}) => {
  useEffect(() => {
    const lightbox = GLightbox({
      selector,
      preload: true,
      ...options,
    });

    return () => {
      lightbox.destroy();
    };
  }, [selector]);
};
